// import Vue from "vue";
// import VueRouter from "vue-router";
// // import NProgress from "nprogress";
// // import Home from "../views/Home.vue";

// Vue.use(VueRouter);

module.exports = [
  {
    path: "/",
    name: "home",
    meta: {
        sitemap: {
            priority:    1,
            changefreq: 'weekly',
        }
    },
    component: () => import('../views/Home.vue')
  },
  {
    path: "/the-firm",
    name: "firm",
    meta: {
        sitemap: {
            priority:    0.8,
            changefreq: 'weekly',
        }
    },
    component: () => import('../views/Firm.vue')
  },
  {
    path: "/capabilities",
    name: "capabilities",
    meta: {
        sitemap: {
            priority:    0.8,
            changefreq: 'weekly',
        }
    },
    component: () => import('../views/Capabilities.vue')
  },
  {
    path: "/our-people",
    meta: {
        sitemap: {
            priority:    0.8,
            changefreq: 'weekly',
        }
    },
    component: () => import('../views/People.vue')
  },
  {
    path: "/page/:alias",
    meta: { sitemap: { ignoreRoute: true } },
    name: "basicpage",
    component: () => import('../views/Page.vue')
  },
  {
    path: "/insights",
    name: "insights",
    meta: {
        sitemap: {
            priority:    0.5,
            changefreq: 'weekly',
        }
    },
    component: () => import('../views/Insights.vue')
  },
  {
    path: "/careers",
    name: "careers",
    meta: {
        sitemap: {
            priority:    0.5,
            changefreq: 'weekly',
        }
    },
    component: () => import('../views/Careers.vue')
  },
  {
    path: "/contact-us",
    name: "contact",
    meta: {
        sitemap: {
            priority:    0.5,
            changefreq: 'weekly',
        }
    },
    component: () => import('../views/Contact.vue')
  },
  {
    path: "/search",
    name: "search",
    meta: { sitemap: { ignoreRoute: true } },
    component: () => import('../views/SearchPage.vue')
  },
  {
    path: "/*",
    name: "notfound",
    meta: { sitemap: { ignoreRoute: true } },
    component: () => import('../views/NotFound.vue')
  },

];

// const router = new VueRouter({
//   mode: "history",
//   base: process.env.BASE_URL,
//   routes
// });

// router.beforeEach((to, from, next) => {
//   // If this isn't an initial page load.
//   window.scrollTo(0, 0);

//   next()
// })

// router.afterEach(() => {
//   // Complete the animation of the route progress bar.
//   // NProgress.done()
// })

// export default router;
